import { TableColumn } from '@Policy/utils/types';
import { TableRow as TableRowType } from '@Policy/DataLossPrevention/Components/ComplianceRulesTransfer';
import React from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableHeader,
  TableHeaderCell,
  TableHeaderRow,
  TableRow,
  TableScrollbar,
  Truncate,
} from '@tonic-one/react';
import { useSlfExceptionStyle } from './styles';
export const ExceptionListTable = React.memo(
  (props: {
    tableStyle: any;
    columns: TableColumn[];
    rows: TableRowType<any>[];
  }) => {
    const { tableStyle, columns, rows } = props;
    const { hoverBackgroundColor, tableHeaderStyleProps } =
      useSlfExceptionStyle();
    const tableHeaderRef = React.useRef<HTMLDivElement>(null);
    const onScrollTableBody = React.useCallback((e: any) => {
      const tableHeader = tableHeaderRef?.current;
      if (!tableHeader) {
        return;
      }
      // Sync the scroll position of the table header and table body for horizontal scrolling
      const scrollLeft = e.target.scrollLeft;
      if (tableHeader.scrollLeft !== scrollLeft) {
        tableHeader.scrollLeft = scrollLeft;
      }
    }, []);
    return (
      <Table layout="flexbox" variant="outline" size="md" {...tableStyle}>
        <TableHeader ref={tableHeaderRef} {...tableHeaderStyleProps}>
          <TableHeaderRow>
            {columns.map((column) => {
              const styleProps = {
                flex: 'none',
                width: column.size,
                ...column.style,
              };
              return (
                <TableHeaderCell key={column.id} {...styleProps}>
                  <Truncate>{column.header}</Truncate>
                </TableHeaderCell>
              );
            })}
          </TableHeaderRow>
        </TableHeader>
        <TableScrollbar
          height="100%"
          overflow="visible" // Make the scrollbar visible
          onScroll={onScrollTableBody} // To sync the scroll position of the table header and table body for horizontal scrolling
        >
          <TableBody>
            {rows.map((row) => {
              const styleProps = {
                _hover: {
                  backgroundColor: hoverBackgroundColor,
                },
              };
              return (
                <TableRow key={row.id} {...styleProps}>
                  {row.cells.map((cell) => {
                    const styleProps = {
                      flex: 'none',
                      width: cell.column.size,
                      ...cell.column.style,
                    };
                    return (
                      <TableCell key={cell.id} {...styleProps}>
                        {typeof cell.column.cell === 'function' ? (
                          cell.column.cell(row)
                        ) : (
                          <Truncate>
                            {
                              cell.row[
                                cell.column.accessorKey as keyof typeof cell.row
                              ]
                            }
                          </Truncate>
                        )}
                      </TableCell>
                    );
                  })}
                </TableRow>
              );
            })}
          </TableBody>
        </TableScrollbar>
      </Table>
    );
  }
);
